import Vue from 'vue'
import './pollyfills'
import VueRouter from 'vue-router'
import VueRouterPrefetch from 'vue-router-prefetch'
import VueNotify from 'vue-notifyjs'
import VeeValidate, { Validator } from 'vee-validate'
import es from 'vee-validate/dist/locale/es';
import lang from 'element-ui/lib/locale/lang/es'
import locale from 'element-ui/lib/locale'
import App from './App.vue'
import VueApollo from 'vue-apollo';
import { ApolloClient } from 'apollo-client';
import { onError } from 'apollo-link-error';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloLink, concat, split } from 'apollo-link';
import store from './store/store'
import SecureLS from 'secure-ls'
import Cookies from 'js-cookie'

// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'
import initProgress from './progressbar';
import { myUrl } from './Settings';
import 'default-passive-events'
import IdleVue from 'idle-vue';

// router setup
import routes from './routes/routes'

// library imports

import './assets/sass/paper-dashboard.scss'
import './assets/sass/demo.scss'

// import sidebarLinks from './sidebarLinks2'
const sidebarLinks = []
// import sidebarLinks from './sidebarLinks'
import './registerServiceWorker'
import { networkInterfaces } from 'os'

// plugin setup
Vue.use(VueRouter)
Vue.use(VueRouterPrefetch)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, {sidebarLinks: sidebarLinks})
Vue.use(VeeValidate, Validator)
Vue.use(VueApollo)

Validator.localize("es", es);
locale.use(lang)

//Asignación del CSRF del backend
// Vue.prototype.$window = window;

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  }
})
const loginRoutes = ['/login','/password_change','/reset_password','/reset']
// Global navigation guards
  router.beforeEach((to, from, next) => {
    var ls = new SecureLS({encodingType: 'aes'});
    // Manejo de errorres para ver si las variable almacenada de manera cifrada están errónea o han sido modificadas
    try {
        Vue.prototype.$adminLoggingIn = ls.get('adminLoggingIn');
        Vue.prototype.$permissions = ls.get('permissions');
        Vue.prototype.$adminAccessToken = ls.get('adminAccessToken');
        Vue.prototype.$adminRefreshToken = ls.get('adminRefreshToken');
        Vue.prototype.$adminTokenExpireDate = ls.get('adminTokenExpireDate');
        if(Vue.prototype.$adminLoggingIn.data){
          if(!Vue.prototype.$permissions || !Vue.prototype.$adminAccessToken || !Vue.prototype.$adminRefreshToken || !Vue.prototype.$adminTokenExpireDate){
            router.go('/login')
          }
        }
    } catch(e) {
        router.go('/login')
    }
    if(to.path.includes('/reset_password'))
    {
      if(!Vue.prototype.$adminLoggingIn.data) next()
      else next('/login')
    }
    else
    {
      if(loginRoutes.indexOf(to.path)<= -1)
      {
        if(!Vue.prototype.$adminLoggingIn.data) next('/login')
        else next()
      }
      else if(loginRoutes.indexOf(to.path) > -1)
      {
        if(Vue.prototype.$adminLoggingIn.data) next('/')
        else next()
      }
      else next()
    }
    
  
  
})
var ls = new SecureLS({encodingType: 'aes'});
Vue.prototype.$token = ls.get('adminAccessToken');
const authMiddleware = new ApolloLink((operation, forward) => {
  var ls = new SecureLS({encodingType: 'aes'});
  Vue.prototype.$token = ls.get('adminAccessToken');
  if (Vue.prototype.$token) {
    operation.setContext({
      headers: {
        authorization: 'jwt '+Vue.prototype.$token.data || null,
        'X-CSRFToken': Cookies.get('csrftoken'),
      }
    });
    return forward(operation);
  }
  else {
    operation.setContext({
      headers: {
        'X-CSRFToken': Cookies.get('csrftoken'),
      }
    });
    return forward(operation);
  }
})

const onErrorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {
  if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }) => {
        console.log(message);
        if(message == "El token de refresco está expirado"){
          store.dispatch('logout').then(()=>{
            router.go('/login');
          });
        }
        if(message == "Token de refresco inválido"){
          store.dispatch('logout').then(()=>{
            router.go('/login');
          });
        }
      })        
  }
});


//httplink
const httpLink = new HttpLink({
  uri: myUrl
})

// Cache implementation
const cache = new InMemoryCache()

// Create the apollo client
const apolloClient = new ApolloClient({
  // link: onErrorLink.concat(httpLink),
  // link: concat(onErrorLink,httpLink,authMiddleware),
  // link: concat(authMiddleware,httpLink, onErrorLink),
  link: ApolloLink.from([onErrorLink,authMiddleware,httpLink]),
  // link:  httpLink,
  cache,
  connectToDevTools: true
})

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

Vue.prototype.$vuexApollo = apolloClient;

initProgress(router);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store,
  apolloProvider
})
